import { Icon } from "@pepperstone/pepper-ui-kit";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDebouncedCallback } from "use-debounce";
import styles from "./SearchInput.module.css";

type SearchInputProps = {
  onChange: (value: string) => void;
  value?: string;
  disabled?: boolean;
  testId?: string;
};

export const SearchInput = ({
  onChange,
  value = "",
  disabled = false,
  testId,
}: SearchInputProps) => {
  const { t } = useTranslation();
  const debounceMs = 300;

  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleChange = useDebouncedCallback((v: string) => {
    onChange(v);
  }, debounceMs);

  return (
    <div className={styles.searchInputContainer}>
      <div className={styles.iconWrapper}>
        <Icon icon="search" size={20} />
      </div>
      <input
        type="search"
        className={styles.searchInput}
        placeholder={t("transactions.history.search_placeholder")}
        value={inputValue}
        onChange={(e) => {
          setInputValue(e.target.value);
          handleChange(e.target.value);
        }}
        disabled={disabled}
        autoComplete="off"
        data-testid={testId}
      />
    </div>
  );
};
